// src/components/Fun.js
import React from 'react';

const Fun = () => {
    return <div className="text-balance font-black font-sans">
    WIP. Come back soon!
  </div>;};

export default Fun;
